/* eslint-disable guard-for-in, no-restricted-syntax*/
import { useEffect, useState } from "react";
import {
  Edit,
  ArrayField,
  TabbedForm,
  FormTab,
  ReferenceManyField,
  Datagrid,
  TextField,
  SelectField,
  BooleanField,
  ShowButton,
  useNotify,
  required,
  maxLength,
  useListContext,
} from "react-admin";
import { Link, useParams } from "react-router-dom";
import ChatBubbleIcon from "@mui/icons-material/ChatBubble";

import { ContentInlineEdit } from "../Content/ContentCreate";
import ContentOrderableList from "../Content/ContentOrderableList";
import resources from "../../constants/resources";
import {
  TOPIC_EDIT_TITLE,
  CONTENT_ORDER_TAB,
  ADD_CONTENT_LABEL,
} from "../../constants/titleConstants";
import {
  CONTENT_TYPES_LIST,
  KUDZU_SITES,
  SITES,
} from "../../constants/contentConstants";
import { formatImage, getNonEmptyValues } from "../../utils/InputUtils";
import { TOPIC_HELPER_TEXT } from "../../constants/helperTextConstants";
import { useOnError } from "../../utils/errorUtils";
import {
  AddAndOrderButtonStyles,
  ImageInputField,
  TextInputField,
} from "../../styles/commonStyles";
import { CONTENT_PARAM_LOCAL } from "../../constants/paramConstants";
import PreviewImage from "../common/PreviewImage";
import { PP_ADMIN_REFERRER } from "../../constants/storageKeys";

const TopicEdit = () => {
  const [contentsTotal, setContentsTotal] = useState(0);

  const { id } = useParams();
  const onError = useOnError(useNotify());

  localStorage.removeItem(CONTENT_PARAM_LOCAL);

  return (
    <Edit
      title={TOPIC_EDIT_TITLE}
      mutationMode="pessimistic"
      mutationOptions={{ onError }}
      transform={getNonEmptyValues}
    >
      <TabbedForm>
        <FormTab label="Summary">
          <TextInputField InputProps={{ disabled: true }} source="id" />
          <TextInputField
            source="name_en"
            validate={[required(), maxLength(50)]}
            helperText={TOPIC_HELPER_TEXT.nameEn}
          />
          <TextInputField
            source="name_es"
            validate={[maxLength(50)]}
            helperText={TOPIC_HELPER_TEXT.nameEs}
          />
          <TextInputField
            multiline
            source="description_en"
            validate={required()}
            helperText={TOPIC_HELPER_TEXT.descriptionEn}
          />
          <TextInputField
            multiline
            source="description_es"
            helperText={TOPIC_HELPER_TEXT.descriptionEs}
          />
          <ImageInputField
            source="cover_image_url"
            format={formatImage}
            label="Cover Image"
            accept="image/*"
            placeholder={<p>Drop your file here</p>}
            helperText={TOPIC_HELPER_TEXT.coverImage}
          >
            <PreviewImage source="src" />
          </ImageInputField>
        </FormTab>
        <FormTab label={resources.CONTENT.label} path="contents">
          <ReferenceManyField
            addLabel={false}
            reference={resources.CONTENT.url}
            target="topic"
            sort={{ field: "order", order: "ASC" }}
          >
            <ContentsDatagrid
              currentContentsTotal={contentsTotal}
              setContentsTotal={setContentsTotal}
            />
          </ReferenceManyField>
          <AddAndOrderButtonStyles
            variant="text"
            component={Link}
            to={`/${resources.CONTENT.url}/create?topic_id=${id}&order=${
              contentsTotal + 1
            }`}
            title={ADD_CONTENT_LABEL}
            startIcon={<ChatBubbleIcon />}
          >
            {ADD_CONTENT_LABEL}
          </AddAndOrderButtonStyles>
        </FormTab>
        <FormTab label={CONTENT_ORDER_TAB} path="content_orderable">
          <ContentOrderableList />
        </FormTab>
      </TabbedForm>
    </Edit>
  );
};

const ContentsDatagrid = props => {
  const { currentContentsTotal, setContentsTotal } = props;
  const { total } = useListContext();

  useEffect(() => {
    if (total !== currentContentsTotal) {
      setContentsTotal(total);
    }
  }, [total]);

  return (
    <Datagrid
      expand={<ContentInlineEdit isExpandMode />}
      bulkActionButtons={false}
      expandSingle
    >
      <TextField source="id" sortable={false} />
      {/* TODO: KD-169 */}
      <ArrayField source="sites" sortable={false}>
        <Datagrid bulkActionButtons={false}>
          <SelectField
            source="id"
            sortable={false}
            choices={
              localStorage.getItem(PP_ADMIN_REFERRER) === KUDZU_SITES[0].title
                ? KUDZU_SITES
                : SITES
            }
            label=""
          />
        </Datagrid>
      </ArrayField>

      <TextField source="name_en" sortable={false} />
      <BooleanField
        label="Is Published"
        source="is_published"
        sortable={false}
      />
      <SelectField
        source="content_type"
        sortable={false}
        choices={CONTENT_TYPES_LIST}
      />
      <ShowButton />
    </Datagrid>
  );
};

export default TopicEdit;
